import { MultiSelectOption } from '../models/MultiSelectOption'

/*
  Map audit type to a translation key
*/
export const auditTypeTranslations: MultiSelectOption[] = [
    {
        value: 'MasterGroup',
        label: 'accessGroup'
    },
    {
        value: 'MasterDetail',
        label: 'customField'
    },
    {
        value: 'MasterAsset',
        label: 'relationship'
    },
    {
        value: 'MasterFloor',
        label: 'floor'
    },
    {
        value: 'Tag',
        label: 'credential'
    },
    {
        value: 'Person / Asset',
        label: 'enrolment'
    },
    {
        value: 'BioTemplate',
        label: 'credential'
    },
    {
        value: 'MasterGroupProfile',
        label: 'accessProfile'
    }
];

/*
  Map audit fields to a translation key.
  Audit fields are not user-friendly so we need to supply an alternative label.
*/
export const auditFieldTranslations: MultiSelectOption[] = [

    // Fields on Master table.
    {
        value: 'mstPin',
        label: 'pinNumber'
    },
    {
        value: 'mstEmailAddress',
        label: 'email'
    },
    {
        value: 'company',
        label: 'company'
    },
    {
        value: 'department',
        label: 'department'
    },
    {
        value: 'mstSuspend',
        label: 'suspend'
    },
    {
        value: 'mstBlacklist',
        label: 'suspendWithAlarm'
    },
    {
        value: 'mstCurrent',
        label: 'enableCredentials'
    },
    {
        value: 'mstDescription',
        label: 'notes'
    },
    {
        value: 'mstDisplayname',
        label: 'displayName'
    },
    {
        value: 'mstGender',
        label: 'gender'
    },
    {
        value: 'mstHosted',
        label: 'hosted'
    },
    {
        value: 'First Name',
        label: 'firstName'
    },
    {
        value: 'mstMiddlename',
        label: 'secondName'
    },
    {
        value: 'Last Name',
        label: 'lastName'
    },
    {
        value: 'mstIdnumber',
        label: 'idNumber'
    },
    {
        value: 'mstNoapb',
        label: 'apbOverride'
    },
    {
        value: 'mstStartDate',
        label: 'startDate'
    },
    {
        value: 'mstSuffix',
        label: 'suffix'
    },
    {
        value: 'mstTitle',
        label: 'title'
    },
    {
        value: 'mstExpiryDate',
        label: 'expiryDate'
    },
    {
        value: 'masterType',
        label: 'accessAndTime'
    },
    {
        value: 'mstReport',
        label: 'report'
    },

    // Fields on Tag table.
    {
        value: 'tagSuspend',
        label: 'suspend'
    },
    {
        value: 'tagGuardTour',
        label: 'scheduledTour'
    },
    {
        value: 'Tag Code',
        label: 'cardNumber'
    },
    {
        value: 'tagCode',
        label: 'cardNumber'
    },
    {
        value: 'tagAccessOverride',
        label: 'accessOverride'
    },
    {
        value: 'tagExpiry',
        label: 'expiryDate'
    },
    {
        value: 'tagExpirytime',
        label: 'expiryTime'
    },
    {
        value: 'tagIssueNo',
        label: 'issueNo'
    },
    {
        value: 'tagSpecialev',
        label: 'specialEvent'
    },
    {
        value: 'tagStart',
        label: 'startDate'
    },
    {
        value: 'tagStarttime',
        label: 'startTime'
    },
    {
        value: 'tagBlacklist',
        label: 'suspendWithAlarm'
    },
    {
        value: 'mstMobileAddress',
        label: 'mobileNumber'
    },
    {
        value: 'vruleEnabled',
        label: 'enabled'
    },
    {
        value: 'vruleExecDatetime',
        label: 'lastTriggered'
    },
    {
        value: 'vruleAuthor',
        label: 'author'
    },
    {
        value: 'vruleName',
        label: 'name'
    },
    {
        value: 'vruleDescription',
        label: 'description'
    },
    {
        value: 'vruleType',
        label: 'type'
    },
    {
        value: 'vruleDisplayType',
        label: 'type'
    }
];
